import { render, staticRenderFns } from "./RewardPrivacyConfirm.vue?vue&type=template&id=2132f004&"
import script from "./RewardPrivacyConfirm.vue?vue&type=script&lang=js&"
export * from "./RewardPrivacyConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-user-dev-002\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2132f004')) {
      api.createRecord('2132f004', component.options)
    } else {
      api.reload('2132f004', component.options)
    }
    module.hot.accept("./RewardPrivacyConfirm.vue?vue&type=template&id=2132f004&", function () {
      api.rerender('2132f004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/survey/components/RewardPrivacyConfirm.vue"
export default component.exports